import React from "react";
import classes from "./Spinner.module.css";
const Spinner = (props) => {
    if(props.size === "small"){
        return(
            <div className={`spinner-border spinner-border-sm  ${classes.Spinner}`} style={{color:"#FF8D1E"}}></div>
        )
    }
    return (
        <div className={`spinner-border  ${classes.Spinner}`} style={{color:"#FF8D1E"}}></div>
    );
}
export default Spinner;

//text-muted